import { isEmpty } from 'lodash-es';
import React from 'react';
import Cldr from 'utils/Cldr';
import I18n from 'utils/I18n';
import { I18nPrefix } from '../../../shared/constants';
import { useCheckoutContext } from '../../../state/CheckoutContext';

import styles from './Overview.scss';

const Overview = () => {
  const { checkoutEntityState } = useCheckoutContext();
  const { duration, isTrial, products, trialInfo } = checkoutEntityState;
  const cartData = products?.[duration];
  const { recurringAmount, currency } = cartData;

  const formattedAmount = Cldr.formatCurrency(recurringAmount, currency);

  const subtitle =
    isTrial && !isEmpty(trialInfo)
      ? I18n.t(`${I18nPrefix}.summary.students.subheading.trial`, {
          numDays: trialInfo.trialLength,
          price: formattedAmount
        })
      : I18n.t(`${I18nPrefix}.summary.students.subheading.organic`, {
          price: formattedAmount
        });

  return (
    <div className={styles.container}>
      <h5 className="text-bold">
        {I18n.t(`${I18nPrefix}.summary.students.annual_student_plan`)}
      </h5>
      <h6>{subtitle}</h6>
    </div>
  );
};

export default Overview;
